import styled from 'styled-components';
import { theme } from '../../styles/theme';

export const Input = styled.input`
  width: 100%;
  padding: 0.75rem 1rem;
  font-size: ${theme.typography.fontSize.base};
  font-family: ${theme.typography.fontFamily};
  color: ${theme.colors.text};
  background-color: ${theme.colors.white};
  border: 2px solid ${theme.colors.border};
  border-radius: ${theme.borderRadius.md};
  transition: all 0.2s ease;
  min-height: 44px;

  &:focus {
    border-color: ${theme.colors.primary};
    outline: none;
    box-shadow: 0 0 0 3px ${theme.colors.primary}15;
  }

  &:disabled {
    background-color: ${theme.colors.secondary};
    cursor: not-allowed;
    opacity: 0.6;
  }

  &::placeholder {
    color: ${theme.colors.textLight};
  }

  /* PIN input styling */
  ${({ isPin }) => isPin && `
    text-align: center;
    font-size: ${theme.typography.fontSize['2xl']};
    font-weight: ${theme.typography.fontWeight.bold};
    letter-spacing: 0.5rem;
    font-family: 'Courier New', monospace;
  `}
`;

export const InputGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${theme.spacing.sm};
  width: 100%;

  label {
    font-size: ${theme.typography.fontSize.sm};
    font-weight: ${theme.typography.fontWeight.semiBold};
    color: ${theme.colors.text};
  }
`;

export const InputWithIcon = styled.div`
  position: relative;
  width: 100%;

  input {
    padding-left: ${({ hasLeftIcon }) => hasLeftIcon ? '3rem' : '1rem'};
    padding-right: ${({ hasRightIcon }) => hasRightIcon ? '3rem' : '1rem'};
  }

  .icon-left {
    position: absolute;
    left: 1rem;
    top: 50%;
    transform: translateY(-50%);
    color: ${theme.colors.textLight};
    pointer-events: none;
  }

  .icon-right {
    position: absolute;
    right: 1rem;
    top: 50%;
    transform: translateY(-50%);
    color: ${theme.colors.textLight};
    pointer-events: none;
  }
`;

